import { css } from 'styled-components';
import { breakpoints } from '../../constants/styles';

// TODO: Define a theme for these types of modals,
// and then add it to the Modal component so we can
// access it wherever.
export const PlanModalEmmanuel = css`
  max-height: none;
  height: auto;
  margin: 0;
  border-radius: 0px;
  width: 90vw;
  max-width: 525px;
  margin-top: 5vh;
  margin-bottom: 5vh;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${breakpoints.tabletLandscape} {
    max-width: 525px;
  }
`;

export const PlanModalToolInProgress1 = css`
  max-height: none;
  height: auto;
  margin: 0;
  border-radius: 0px;
  width: 90vw;
  max-width: 525px;
  margin-top: 5vh;
  margin-bottom: 5vh;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const PlanModalMaria = css`
  max-height: none;
  height: auto;
  margin: 0;
  border-radius: 0px;
  width: 90vw;
  max-width: 425px;
  margin-top: 5vh;
  margin-bottom: 5vh;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${breakpoints.tabletLandscape} {
    max-width: 425px;
  }
`;